import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { from, Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Injectable()
export class CompressionInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!request.body) {
      return next.handle(request);
    }

    const bodyBlob = new Blob([JSON.stringify(request.body)], { type: 'application/json' });
    if (bodyBlob.size > 30000000) { // default max body size for .net
      const stream = bodyBlob.stream();
      const compressedStream = stream.pipeThrough(new CompressionStream("gzip"));
      const compressedData$ = from(new Response(compressedStream).arrayBuffer());
      return compressedData$.pipe(
        switchMap(buffer => {
          const headers = request.headers.set('Content-Encoding', 'gzip').set('Content-Type', 'application/json');
          const newReq = request.clone({ body: buffer, headers });

          return next.handle(newReq);
        }));
      }

      return next.handle(request);
  }
}
